import {
  http
} from '../config';
import base from './base';

export const prebooked={
  getprebookedList(currPage){//获取未打开时间的待续课列表
    return http({
      url:`${base.datebook}/teacherClass/preBookedUnOpen/${currPage}`,
      method:'get',
    });
  },
  updatePrebookedTime(data){
    return http({
      url:`${base.datebook}/teacherClass/updatePreBookedTime`,
      method:'post',
      data
    });
  },
  teaApplyList(data){
    return http({
      url:`${base.datebook}/vipApply/teaApplyList`,
      method:'post',
      data
    });
  },
  teaApplyAudit(data){
    return http({
      url:`${base.datebook}/vipApply/teaApplyAudit`,
      method:'post',
      data
    });
  },
  updateBatchPreBookedTime(data){
    return http({
      url:`${base.datebook}/teacherClass/updateBatchPreBookedTime`,
      method:'post',
      data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/prebooked.js